import { render, staticRenderFns } from "./ReturnListModal.vue?vue&type=template&id=f8df1934"
import script from "./ReturnListModal.vue?vue&type=script&lang=js"
export * from "./ReturnListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports